export default {
  cardButton: {
    clickVisualizar: "Haga clic para ver",
    rs: "US$"
  }
};
